import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Leaf } from 'lucide-react';
import '../styles/GalleryPage.css';

const GalleryPage = () => {
  const navigate = useNavigate();

  // Avant/Après Fertilisation
  const beforeAfterFertilization = {
    before: "https://images.unsplash.com/photo-1614722529491-6a2ba61c9eec?w=800&q=85",
    after: "https://images.unsplash.com/photo-1641911809680-f94c0fcc0fdb?w=800&q=85",
    title: "Résultat fertilisation naturelle",
    description: "8 semaines de traitement naturel"
  };

  // Haies de cèdre
  const hedgeProjects = [
    {
      image: "https://images.unsplash.com/photo-1759502141256-45d54807853b?w=800&q=85",
      title: "Haies de cèdre impeccables",
      location: "Résidence Estrie"
    },
    {
      image: "https://images.unsplash.com/photo-1766228271529-7aac76cca4c9?w=800&q=85",
      title: "Bordure de cèdres mature",
      location: "Propriété Sherbrooke"
    },
    {
      image: "https://images.unsplash.com/photo-1607699015736-bab303617062?w=800&q=85",
      title: "Haie d'intimité dense",
      location: "Magog"
    }
  ];

  // Terrains complets
  const propertyViews = [
    {
      image: "https://images.unsplash.com/photo-1759412393800-0ac06909423a?w=800&q=85",
      title: "Résidence avec pelouse parfaite",
      location: "Estrie"
    },
    {
      image: "https://images.unsplash.com/photo-1762967227007-e75cfcc2d932?w=800&q=85",
      title: "Terrain verdoyant mature",
      location: "Bromont"
    },
    {
      image: "https://images.unsplash.com/photo-1772040942277-b194d9d0b648?w=800&q=85",
      title: "Aménagement paysager complet",
      location: "Sherbrooke"
    }
  ];

  return (
    <div className="gallery-page-new">
      {/* Hero Section */}
      <section className="realisations-hero">
        <div className="container">
          <div className="hero-badge-new">
            <Leaf size={20} />
            <span>NOS RÉALISATIONS</span>
          </div>
          <h1>Portfolio de Projets</h1>
          <p>Découvrez la qualité de notre travail à travers nos réalisations en Estrie</p>
        </div>
      </section>

      {/* Avant/Après */}
      <section className="section-realisations">
        <div className="container">
          <div className="section-title-center">
            <h2>Avant / Après Fertilisation</h2>
            <p>Transformation naturelle de votre pelouse</p>
          </div>

          <div className="before-after-container">
            <div className="before-after-wrapper">
              <div className="ba-image-box">
                <div className="ba-label ba-before">AVANT</div>
                <img src={beforeAfterFertilization.before} alt="Avant fertilisation" />
              </div>
              
              <div className="ba-arrow">
                <ArrowRight size={40} />
              </div>
              
              <div className="ba-image-box">
                <div className="ba-label ba-after">APRÈS</div>
                <img src={beforeAfterFertilization.after} alt="Après fertilisation" />
              </div>
            </div>
            
            <div className="ba-description">
              <h3>{beforeAfterFertilization.title}</h3>
              <p>{beforeAfterFertilization.description}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Haies */}
      <section className="section-realisations section-alt">
        <div className="container">
          <div className="section-title-center">
            <h2>Taille de Haies de Cèdre</h2>
            <p>Entretien professionnel pour haies denses et uniformes</p>
          </div>

          <div className="gallery-grid-new">
            {hedgeProjects.map((project, index) => (
              <div key={index} className="gallery-card-new">
                <div className="card-image-wrapper">
                  <img src={project.image} alt={project.title} />
                </div>
                <div className="card-content-new">
                  <h3>{project.title}</h3>
                  <p className="location-tag">{project.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Terrains */}
      <section className="section-realisations">
        <div className="container">
          <div className="section-title-center">
            <h2>Terrains Résidentiels</h2>
            <p>Pelouses verdoyantes et impeccables</p>
          </div>

          <div className="gallery-grid-new">
            {propertyViews.map((project, index) => (
              <div key={index} className="gallery-card-new">
                <div className="card-image-wrapper">
                  <img src={project.image} alt={project.title} />
                </div>
                <div className="card-content-new">
                  <h3>{project.title}</h3>
                  <p className="location-tag">{project.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section-realisations section-cta-final">
        <div className="container">
          <div className="cta-box-final">
            <h2>Transformez votre terrain</h2>
            <p>Obtenez une soumission gratuite pour votre projet</p>
            <button className="btn-primary btn-large" onClick={() => navigate('/contact')}>
              Demander une soumission
              <ArrowRight size={22} />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GalleryPage;
